import { readingAssessmentInstruction } from "@constants/instructionConstants";
import { virtualAssistanceReadingAssessmentConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  TestUIConfiguration,
  ReadingAssessmentCustomConfiguration,
} from "types/testTypes";
import { CATEGORY_VERSION_MAP, TEST_TYPE_VERSION_MAP } from "../versionConstants";
import {
  READING_ASSESSMENT_SUPPORTED_LANGUAGES,
  VIRTUAL_ASSISTANT_LANGUAGE_LIST,
} from "@constants/languageConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
  CALIBRATION_TOGGLE_OPTION,
  DUMMY_AVAILABLE_TEST_SPECIFIC_CONFIGURATION_OPTIONS,
} from "../configurationHelperConstants";

export const availableReadingAssessmentTestConfigurationOptions: AvailablePreTestConfigurationOptions =
  {
    testTypes: {
      validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.ReadingAssessment],
      choices: [
        {
          validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.ReadingAssessment],
          value: TestType.ReadingAssessment,
        },
      ],
      isMandatory: true,
      configurationFieldName: "testType",
    },
    eyeConfigurationOptions: {
      ...AVAILABLE_EYE_OPTIONS_BINOCULAR,
      toggleCalibrationOption: { ...CALIBRATION_TOGGLE_OPTION },
    },
    languageOptions: null,
    virtualAssistantOptions: {
      ...AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
      choices: VIRTUAL_ASSISTANT_LANGUAGE_LIST,
    },
    testSpeedOptions: null,
    testSpecificConfigurationOptions: {
      ...DUMMY_AVAILABLE_TEST_SPECIFIC_CONFIGURATION_OPTIONS,
      textListType: {
        validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.ReadingAssessment],
        choices: [],
        isMandatory: true,
        configurationFieldName: "textListType",
      },
      toggleShowComprehensionQuestions: {
        choices: null,
        validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.ReadingAssessment],
        configurationFieldName: "showComprehensionQuestions",
      },
    },
  };

export const readingAssessmentTestConfiguration: TestConfiguration = {
  name: TestCategory.ReadingAssessment,
  testType: TestType.ReadingAssessment,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: false,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: null,
  testLanguage: READING_ASSESSMENT_SUPPORTED_LANGUAGES[1].value,
  virtualAssistanceConfig: virtualAssistanceReadingAssessmentConfig,
  isPressToStartEnabled: true,
  extraData: {
    testIds: [],
    textListType: "",
    showComprehensionQuestions: true,
  } as ReadingAssessmentCustomConfiguration,
};

export const readingAssessmentUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: readingAssessmentInstruction,
};

export const RA_MILLISECOND_DETECTION_THRESHOLD = 2;
export const RA_EXCESSIVE_FIXATION_THRESHOLD_SEC = 0.23;
export const RA_LINE_CHANGE_Y_PCT_THRESHOLD = 2.5;
